import { render, staticRenderFns } from "./reaktionen-nachweise.vue?vue&type=template&id=a729034c&scoped=true&"
import script from "./reaktionen-nachweise.vue?vue&type=script&lang=js&"
export * from "./reaktionen-nachweise.vue?vue&type=script&lang=js&"
import style0 from "./reaktionen-nachweise.vue?vue&type=style&index=0&id=a729034c&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a729034c",
  null
  
)

export default component.exports